import { render, staticRenderFns } from "./ProductionManagement.vue?vue&type=template&id=f4e82e94&scoped=true"
import script from "./ProductionManagement.vue?vue&type=script&lang=js"
export * from "./ProductionManagement.vue?vue&type=script&lang=js"
import style0 from "./ProductionManagement.vue?vue&type=style&index=0&id=f4e82e94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e82e94",
  null
  
)

export default component.exports